// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v1/dataset_response.proto (package chalk.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChalkError } from "./chalk_error_pb";
import { file_chalk_common_v1_chalk_error } from "./chalk_error_pb";
import type { QueryStatus } from "./query_status_pb";
import { file_chalk_common_v1_query_status } from "./query_status_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/common/v1/dataset_response.proto.
 */
export const file_chalk_common_v1_dataset_response: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_common_v1_chalk_error, file_chalk_common_v1_query_status, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.common.v1.DatasetSampleFilter
 */
export type DatasetSampleFilter = Message<"chalk.common.v1.DatasetSampleFilter"> & {
  /**
   * @generated from oneof chalk.common.v1.DatasetSampleFilter.lower_bound_filter
   */
  lowerBoundFilter: {
    /**
     * @generated from field: google.protobuf.Timestamp lower_bound = 1;
     */
    value: Timestamp;
    case: "lowerBound";
  } | {
    /**
     * @generated from field: google.protobuf.Duration lower_bound_delta = 4;
     */
    value: Duration;
    case: "lowerBoundDelta";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from oneof chalk.common.v1.DatasetSampleFilter.upper_bound_filter
   */
  upperBoundFilter: {
    /**
     * @generated from field: google.protobuf.Timestamp upper_bound = 2;
     */
    value: Timestamp;
    case: "upperBound";
  } | {
    /**
     * @generated from field: google.protobuf.Duration upper_bound_delta = 5;
     */
    value: Duration;
    case: "upperBoundDelta";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional int32 max_samples = 3;
   */
  maxSamples?: number;
};

/**
 * Describes the message chalk.common.v1.DatasetSampleFilter.
 * Use `create(DatasetSampleFilterSchema)` to create a new message.
 */
export const DatasetSampleFilterSchema: GenMessage<DatasetSampleFilter> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_dataset_response, 0);

/**
 * @generated from message chalk.common.v1.DatasetFilter
 */
export type DatasetFilter = Message<"chalk.common.v1.DatasetFilter"> & {
  /**
   * @generated from field: chalk.common.v1.DatasetSampleFilter sample_filters = 1;
   */
  sampleFilters?: DatasetSampleFilter;

  /**
   * @generated from field: optional float max_cache_age_secs = 2;
   */
  maxCacheAgeSecs?: number;
};

/**
 * Describes the message chalk.common.v1.DatasetFilter.
 * Use `create(DatasetFilterSchema)` to create a new message.
 */
export const DatasetFilterSchema: GenMessage<DatasetFilter> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_dataset_response, 1);

/**
 * @generated from message chalk.common.v1.DatasetRevisionResponse
 */
export type DatasetRevisionResponse = Message<"chalk.common.v1.DatasetRevisionResponse"> & {
  /**
   * @generated from field: optional string dataset_name = 1;
   */
  datasetName?: string;

  /**
   * @generated from field: optional string dataset_id = 2;
   */
  datasetId?: string;

  /**
   * @generated from field: optional string environment_id = 3;
   */
  environmentId?: string;

  /**
   * @generated from field: optional string revision_id = 4;
   */
  revisionId?: string;

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string;

  /**
   * @generated from field: repeated string outputs = 6;
   */
  outputs: string[];

  /**
   * @generated from field: optional string givens_uri = 7;
   */
  givensUri?: string;

  /**
   * @generated from field: chalk.common.v1.QueryStatus status = 8;
   */
  status: QueryStatus;

  /**
   * @generated from field: chalk.common.v1.DatasetFilter filters = 9;
   */
  filters?: DatasetFilter;

  /**
   * @generated from field: int32 num_partitions = 10;
   */
  numPartitions: number;

  /**
   * @generated from field: optional int32 num_bytes = 11;
   */
  numBytes?: number;

  /**
   * @generated from field: string output_uris = 12;
   */
  outputUris: string;

  /**
   * @generated from field: int32 output_version = 13;
   */
  outputVersion: number;

  /**
   * @generated from field: optional string branch = 14;
   */
  branch?: string;

  /**
   * @generated from field: optional string dashboard_url = 15;
   */
  dashboardUrl?: string;

  /**
   * @generated from field: optional int64 num_rows = 16;
   */
  numRows?: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_at = 101;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 102;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp terminated_at = 103;
   */
  terminatedAt?: Timestamp;
};

/**
 * Describes the message chalk.common.v1.DatasetRevisionResponse.
 * Use `create(DatasetRevisionResponseSchema)` to create a new message.
 */
export const DatasetRevisionResponseSchema: GenMessage<DatasetRevisionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_dataset_response, 2);

/**
 * @generated from message chalk.common.v1.DatasetResponse
 */
export type DatasetResponse = Message<"chalk.common.v1.DatasetResponse"> & {
  /**
   * Whether the export job is finished (it runs asynchronously)
   *
   * @generated from field: bool is_finished = 1;
   */
  isFinished: boolean;

  /**
   * Version number representing the format of the data. The client uses this version number
   * to properly decode and load the query results into DataFrames.
   *
   * @generated from field: int32 version = 2;
   */
  version: number;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string dataset_id = 4;
   */
  datasetId: string;

  /**
   * @generated from field: string dataset_name = 5;
   */
  datasetName: string;

  /**
   * @generated from field: repeated chalk.common.v1.ChalkError errors = 101;
   */
  errors: ChalkError[];

  /**
   * @generated from field: repeated chalk.common.v1.DatasetRevisionResponse revisions = 102;
   */
  revisions: DatasetRevisionResponse[];
};

/**
 * Describes the message chalk.common.v1.DatasetResponse.
 * Use `create(DatasetResponseSchema)` to create a new message.
 */
export const DatasetResponseSchema: GenMessage<DatasetResponse> = /*@__PURE__*/
  messageDesc(file_chalk_common_v1_dataset_response, 3);

